module.exports = __webpack_public_path__ + "4d982e85e28aed5b5787d0185a7d012d.pdf";